export const parameters = {
  isDevelopment: process.env.NODE_ENV === 'development',
  websiteUrl: process.env.REACT_APP_WEBSITE_URL,
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
  },
};
